module.exports = __webpack_public_path__ + "static/img/background1.17f80c85.png";